import { render, staticRenderFns } from "./ImageRatioModal.vue?vue&type=template&id=8af009da&scoped=true"
import script from "./ImageRatioModal.vue?vue&type=script&lang=js"
export * from "./ImageRatioModal.vue?vue&type=script&lang=js"
import style0 from "./ImageRatioModal.vue?vue&type=style&index=0&id=8af009da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af009da",
  null
  
)

export default component.exports